// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "input[type=\"number\"].cb28c8684d90a414e {\r\n    margin-top: 6px;\r\n}", "",{"version":3,"sources":["webpack://./src/Views/Conditions.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB","sourcesContent":["input[type=\"number\"].budgetInput {\r\n    margin-top: 6px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"budgetInput": "cb28c8684d90a414e"
};
export default ___CSS_LOADER_EXPORT___;
